import { Row } from "@tanstack/react-table";

import { Button } from "@/components/ui/button/button";
import { useSalarySlipModal } from "../salary-slip-modal/use-salary-slip-modal";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const originData = row.original as {
    approved: boolean;
    employee: {
      _id: string;
      name: string;
      email: string;
    };
    createdAt: string | Date;
    netPay: number;
    totalEarnings: number;
    totalDeductions: number;
    notes: string;
    period: string;
    month: string;
    year: number;
    daysInMonth: number;
    daysPayable: number;
    components: {
      type: string;
      amount: number;
      name: string;
      description: string;
    }[];
    id: string;
  };

  const {
    onOpenChange: onOpenGenerateSlipModal,
    setSalary: setGenerateSlipSalary,
  } = useSalarySlipModal();

  return (
    <div className="flex items-center gap-4">
      <Button
        size="sm"
        variant="default"
        onClick={() => {
          setGenerateSlipSalary(originData);
          onOpenGenerateSlipModal(true);
        }}
      >
        View
      </Button>
    </div>
  );
}
